/* ARSHÉ V16 — Search UI interactions only. Shopify search/filter/sort remain native. */
(function () {
  function initSearch() {
    if (!document.body.classList.contains('template-search')) return;

    const input = document.querySelector('.template-search .template-search__search input[type=\"search\"]');
    if (!input) return;

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && input.value) {
        input.value = '';
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.focus();
      }
    });

    document.querySelectorAll('.template-search .facets__summary, .template-search .mobile-facets__summary').forEach(function (summary) {
      summary.addEventListener('click', function () {
        summary.classList.add('arshe-filter-touched');
        window.setTimeout(function () { summary.classList.remove('arshe-filter-touched'); }, 350);
      });
    });

    // If the native mobile drawer exists, keep body scroll state clean when it closes.
    const wrapper = document.querySelector('.template-search .mobile-facets__wrapper');
    if (wrapper) {
      wrapper.addEventListener('click', function (event) {
        const close = event.target.closest('.mobile-facets__close, .mobile-facets__close-button');
        if (close) window.setTimeout(function () { document.documentElement.classList.remove('overflow-hidden'); }, 40);
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSearch);
  else initSearch();
})();
